const SET_SUBSCRIBER_TYPE = (state, payload) => {
    state.subscriber_type = '';
    state.subscriber_type = payload;
}
const CLEAR_SUBSCRIBER_TYPE = (state) => {
    state.subscriber_type = '';
}

const SET_SUBSCRIBE_RESPONSE = (state, payload) => {
    state.subscribe_response = {};
    state.subscribe_response = payload;
}
const CLEAR_SUBSCRIBE_RESPONSE = (state) => {
    state.subscribe_response = {};
}

const SET_TRANSITION_USERID = (state, payload) => {
    state.transition_userid = '';
    state.transition_userid = payload;
}
const CLEAR_TRANSITION_USERID = (state) => {
    state.transition_userid = '';
}

const SET_TRANSITION_CSMATNO = (state, payload) => {
    state.transition_csmatno = '';
    state.transition_csmatno = payload;
}
const CLEAR_TRANSITION_CSMATNO = (state) => {
    state.transition_csmatno = '';
}

const SET_TRANSITION_CSORDERNO = (state, payload) => {
    state.transition_csorderno = '';
    state.transition_csorderno = payload;
}
const CLEAR_TRANSITION_CSORDERNO = (state) => {
    state.transition_csorderno = '';
}

const SET_TRANSITION_TYPE = (state, payload) => {
    state.transition_type = '';
    state.transition_type = payload;
}
const CLEAR_TRANSITION_TYPE = (state) => {
    state.transition_type = '';
}

const CLEAR_STATES = (state) => {
    state.subscriber_type = '';
    state.subscribe_response = {};
    state.transition_userid = '';
    state.transition_csmatno = '';
    state.transition_csorderno = '';
    state.transition_type = '';
}

export {
    SET_SUBSCRIBER_TYPE,
    CLEAR_SUBSCRIBER_TYPE,
    SET_SUBSCRIBE_RESPONSE,
    CLEAR_SUBSCRIBE_RESPONSE,
    SET_TRANSITION_USERID,
    CLEAR_TRANSITION_USERID,
    SET_TRANSITION_CSMATNO,
    CLEAR_TRANSITION_CSMATNO,
    SET_TRANSITION_CSORDERNO,
    CLEAR_TRANSITION_CSORDERNO,
    SET_TRANSITION_TYPE,
    CLEAR_TRANSITION_TYPE,
    CLEAR_STATES
}
